/** 市检使用工地日期：日期字符串按 UTC 做纯日历运算，避免夏令时和电脑时区造成跨日。 */
export const inspectionToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Los_Angeles", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
export const shiftInspectionDay = (day, offset) => {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + offset);
  return date.toISOString().slice(0, 10);
};
export const inspectionWeekStart = (day) => shiftInspectionDay(day, -((new Date(`${day}T12:00:00Z`).getUTCDay() + 6) % 7));

/** 周历需要提醒已过期且仍未录入结果的市检，不能把整改或已通过再次当作漏填。
 * 上午/下午与结果提醒任务使用同一截止口径（12:00/17:00）；时段待定不猜当天钟点，
 * 到工地次日才标红。使用洛杉矶墙上时间，避免国内同事电脑时区或夏令时导致提前报警。
 * 此处仅决定显示，不受后台短信“仅补今日/昨日”的防群发限制，历史周也要看得出漏填。
 */
export function isInspectionResultOverdue(row, now = new Date()) {
  if (row.status !== "scheduled" || row.result || !Number.isFinite(now.getTime())) return false;
  const day = row.confirmedDate;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day || "")) return false;
  const parsed = new Date(`${day}T12:00:00Z`);
  if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== day) return false;
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(now).map(({ type, value }) => [type, value]));
  const today = `${parts.year}-${parts.month}-${parts.day}`;
  if (day !== today) return day < today;
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  return row.confirmedPeriod === "am" ? minutes >= 720 : row.confirmedPeriod === "pm" && minutes >= 1020;
}
